<app-page-wrapper>
    <span class="link breadcrumb-link" (click)="goBack()">
      <i class="far fa-angle-left"></i> Back
    </span>
    <div class="mt-2"></div>
    <app-onboarding-banner [bannerText]="'Upload rostering file'"></app-onboarding-banner>
    <div *ngIf="lastSync.LastSyncDate">
        Last successful import: {{longDateFormat(lastSync.LastSyncDate)}} {{ lastSync.Name ? "by " + lastSync.Name : "" }}
    </div>
    <div *ngIf="lastSync.LastSyncDate">
        <a (click)="downloadRoster()" class="underline">Download existing roster</a>
    </div>
    <div class="row mt-4">
        <div class="col-6 template-box">
            <div class="padding">
                <img class="icon" src="assets/icon-download-template.svg">
                <div class="header">Download Template</div>
                <div class="mb-4">for importing a school</div>
                <a href="assets/JoySchool_Import_Template.xlsx" download="JoySchool_Import_Template.xlsx">
                    <button class="btn btn-primary">Download blank template</button>
                </a>
            </div>
        </div>
        <div class="col-6 upload-box" appDragFile (fileDrop)="handleFileDrop($event)">
            <div class="padding">
                <img class="icon" src="assets/icon-upload-template.svg">
                <div class="header">Drag and drop your file to upload</div>
                <div class="mb-4">or browse for the file</div>
                <label class="btn btn-primary" for="file-upload">
                    Choose file
                </label>
                <input id="file-upload" (change)="handleFileInput($event)" type="file" accept=".xlsx">
            </div>
        </div>
    </div>
    <div class="results-box mt-5" *ngIf="errors.length || warnings.length || importedOrg">
        <div *ngIf="errors.length">
            <div class="header error-message mt-0">Errors</div>
            <div class="horizontal-separator"></div>
            <div *ngFor="let error of errors" class="error-message">
                {{ error }}
            </div>
        </div>
        <div *ngIf="warnings.length">
            <div class="header warning-message mt-0">Warnings</div>
            <div class="horizontal-separator"></div>
            <div *ngFor="let warning of warnings" class="warning-message">
                {{ warning }}
            </div>
            <div *ngIf="importedOrg" class="horizontal-separator"></div>
            <div *ngIf="importedOrg" class="horizontal-separator"></div>
        </div>
        <div *ngIf="importedOrg">
            <div class="d-flex justify-content-between preview-header">
                <div>
                    <div class="header mt-0">Preview</div>
                    <div>If this data looks correct, click Import</div>
                </div>
                <div>
                    <button *ngIf="!importing" class="btn btn-primary" (click)="startImport($event)">Import</button>
                    <app-loading-spinner *ngIf="importing" text="" noMargin="true"></app-loading-spinner>
                </div>
            </div>
            <div class="horizontal-separator"></div>
            <div class="section-header">Staff</div>
            <ul>
                <li *ngFor="let staff of importedOrg.Staff">
                    {{ staff.name }} &mdash; {{ staff.email }} &mdash; {{ staff.role }}
                </li>
            </ul>
            <div class="section-header">Classes</div>
            <ul>
                <li *ngFor="let _class of classData">
                    {{ _class.name }} &mdash; {{ _class.level }}
                </li>
            </ul>
            <div class="section-header">Students</div>
            <ul>
                <li *ngFor="let _class of classData">
                    <b>{{ _class.name }}{{ _class.teacherName ? " — "+_class.teacherName : "" }}</b>
                    <ul>
                        <li *ngFor="let student of getStudentsForClass(_class.name)">
                            {{ student.name }} &mdash; {{ student.externalId }} {{ studentParentText(student) }}
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</app-page-wrapper>